import SectionHeader from '@Web/Src/Components/SectionHeader';
import { TUTORIALS } from '@Web/Pages/Web/Home/constants.jsx';
import Loading from '@Web/Src/UI/Loading';

const TutorialsLazy = () => {
    return (
        <div className='bg-dark small:px-6 mt-44 w-full rounded-3xl px-12 pb-24 pt-16'>
            <SectionHeader
                className='mx-auto'
                type='light'
                icon='youtube'
                title={__('Learn how to use our referral software')}
                desc={__(
                    'Learn how to build and launch your own referral program or affiliate program. Our YouTube channel offers expert tips and tutorials. Watch our bite-sized videos and see how easy it is to use our customer referral program software.'
                )}
            />
            <div className='large:flex-col mx-auto mt-14 flex max-w-5xl items-center gap-8'>
                <Loading color={'#ffffff'} />
                <div className='hidden min-w-[240px] flex-1'>
                    <p className='font-bold'>{__('OUR TUTORIALS')}</p>
                    <p>
                        {TUTORIALS.map((item, index) => {
                            return <p key={index}>{item.title}</p>;
                        })}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TutorialsLazy;
